module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_szerzkot2.fa0613a8.jpg";